module.exports = __webpack_public_path__ + "media/images/riders/small/ANNIKA_LANGVAD-20329096ad4c467d216aaed18e159528.png";